import { supabase } from "@/integrations/supabase/client";
import type { Branding, BrandingUpdateInput } from "../types";

/**
 * Camada de serviços do módulo Branding (identidade visual da tela de login).
 * Apenas chamadas Supabase puras — sem React, sem toasts.
 */

export async function fetchBranding(): Promise<Branding | null> {
  const { data, error } = await supabase
    .from("branding_settings")
    .select("id, titulo, subtitulo, orgao_nome, logo_url")
    .limit(1)
    .maybeSingle();
  if (error) throw error;
  return (data as Branding) ?? null;
}

export async function updateBranding(
  id: string,
  input: BrandingUpdateInput,
): Promise<void> {
  const { error } = await supabase
    .from("branding_settings")
    .update(input)
    .eq("id", id);
  if (error) throw error;
}

export async function uploadBrandingLogo(file: File): Promise<string> {
  const ext = file.name.split(".").pop() || "png";
  const path = `logo-${Date.now()}.${ext}`;
  const { error } = await supabase.storage.from("branding").upload(path, file, {
    cacheControl: "3600",
    upsert: false,
  });
  if (error) throw error;
  const { data } = supabase.storage.from("branding").getPublicUrl(path);
  return data.publicUrl;
}
